import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

domReady(() => {
  const formateursCarousels = document.querySelectorAll(
    '.formateurs-carousel--is-carousel'
  );

  if (0 < formateursCarousels.length) {
    formateursCarousels.forEach((formateursCarousel) => {
      new Swiper(
        formateursCarousel.querySelector('.formateurs-carousel__carousel'),
        {
          slidesPerView: 1,
          spaceBetween: 10,
          speed: 700,

          breakpoints: {
            600: {
              slidesPerView: 2,
              spaceBetween: 30,
              // centeredSlides: true,
            },
            768: {
              slidesPerView: 2.4,
              spaceBetween: 30,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          },

          navigation: {
            prevEl: [...formateursCarousel.querySelectorAll('.swiper-button-prev')],
            nextEl: [...formateursCarousel.querySelectorAll('.swiper-button-next')],
          },
        }
      );
    });
  }
});
